const { Fragment, useState, useRef, useEffect } = wp.element;
const { PanelBody, PanelRow, Button, __experimentalNumberControl: NumberControl, TextControl, FormToggle, SelectControl, TextareaControl, ButtonGroup, __experimentalUnitControl: UnitControl } = wp.components;
const { __ } = wp.i18n;
import BMediaUpload from "../../BMediaUpload";

const Quality = ({ attributes, setAttributes }) => {
  const { quality } = attributes;

  const handleQuality = (property, value, index) => {
    const newQuality = [...quality];
    newQuality[index] = { ...newQuality[index], [property]: value };
    setAttributes({ quality: newQuality });
  };

  const removQuality = (index) => {
    const newQuality = [...quality];
    newQuality.splice(index, 1);
    setAttributes({ quality: newQuality });
  };

  return (
    <PanelBody className="" title={__("Quality", "h5vp")} initialOpen={false}>
      {quality.map((item, index) => {
        return (
          <PanelBody title={item.size || "Resulation"} initialOpen={false} className="subtitleItem">
            <PanelRow className="width-100">
              <TextControl value={item?.size} onChange={(size) => handleQuality("size", size, index)} placeholder={"Resolution"} />
            </PanelRow>
            <BMediaUpload
              // type={["audio/mp4"]}
              onSelect={(source) => handleQuality("video_file", source, index)}
              value={item?.video_file}
              placeholder="Video"
            />
            <Button onClick={() => removQuality(index)}>{__("Remove", "h5vp")}</Button>
          </PanelBody>
        );
      })}
      <Button
        isPrimary
        onClick={() => {
          setAttributes({ quality: [...quality, { size: "size" }] });
        }}
      >
        {__("Add More", "h5vp")}
      </Button>
    </PanelBody>
  );
};

export default Quality;
